import { StudentApplicationOffer } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface GetParams {
  studentApplicationId: string;
}

const { useFind: useStudentApplicationOffers } = getCRUDHooks<StudentApplicationOffer>({
  entityName: 'studentApplicationOffer',
  find: ({ studentApplicationId }: GetParams) =>
    clientApi
      .getOCClient()
      .helpers.studentApplication.studentApplication.id(studentApplicationId)
      .offers.find(),
});

// eslint-disable-next-line import/prefer-default-export
export { useStudentApplicationOffers };
